import { getToken } from "@/lib/api";

const BASE = process.env.REACT_APP_BACKEND_URL;

export async function openAgreementPdf(path, filename = "agreement.pdf") {
  const inline = navigator.pdfViewerEnabled !== false;
  const win = inline ? window.open("", "_blank") : null;
  const res = await fetch(`${BASE}/api/agreements/${path}`, { headers: { Authorization: `Bearer ${getToken()}` } });
  if (!res.ok) { win?.close(); throw new Error("Couldn't open the agreement."); }
  const url = URL.createObjectURL(await res.blob());
  if (win) { win.location.href = url; return; }
  const a = document.createElement("a");
  a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
}

export async function uploadAgreement(userId, file) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await fetch(`${BASE}/api/agreements/admin/${userId}/upload`, { method: "POST", headers: { Authorization: `Bearer ${getToken()}` }, body: fd });
  const j = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof j.detail === "string" ? j.detail : "Upload failed");
  return j;
}

export const tenureText = (t) => {
  if (!t) return "";
  const y = t.years ? `${t.years} year${t.years === 1 ? "" : "s"}` : "";
  const m = t.months ? `${t.months} month${t.months === 1 ? "" : "s"}` : "";
  return [y, m].filter(Boolean).join(", ") || "Less than a month";
};
